module.exports = __webpack_public_path__ + "static/media/wechatcode.228fef55.png";